import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { AccessibilityInfo } from 'react-native';

/**
 * Tells a screen reader what a tap just changed, such as a point leaving the
 * reply. Queued rather than spoken at once, so it does not cut off the label
 * of the button that was pressed.
 *
 * Web has no such call; the draft keeps a polite live region there instead.
 */
export function announce(message: string) {
  if (isWeb) {
    return;
  }

  AccessibilityInfo.announceForAccessibilityWithOptions(message, { queue: true });
}
